import { createFileRoute } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";

import NewCostCenterForm from "@/features/settings/basic-settings/NewCostCenterForm";
import { CostCenterDataProvider } from "@/features/settings/cost-centers-table/cost-centers-data-provider";
import { CostCentersTable } from "@/features/settings/cost-centers-table/cost-centers-table";
import { CostCenterTableInstanceProvider } from "@/features/settings/cost-centers-table/table-instance-provider";

export const Route = createFileRoute(
  "/_authenticated/$company/unternehmen/_settings/einstellungen/kostenstellen",
)({
  component: CostCenters,
});

function CostCenters() {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col">
      <div className="flex-1 flex flex-col">
        <div className="font-bold text-xl mb-5">
          {t("cost_centers.cost_centers")}
        </div>
        <CostCenterDataProvider>
          <CostCenterTableInstanceProvider>
            <NewCostCenterForm />
            <CostCentersTable />
          </CostCenterTableInstanceProvider>
        </CostCenterDataProvider>
      </div>
    </div>
  );
}
